export default __webpack_public_path__ + "static/thumbnail_accessibility-2c9a84fb1442910e1d43ad7f11904c6a.png";